var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4999 20.833C17.1023 20.833 20.8333 17.102 20.8333 12.4997C20.8333 7.8973 17.1023 4.16634 12.4999 4.16634C7.89755 4.16634 4.16659 7.8973 4.16659 12.4997C4.16659 17.102 7.89755 20.833 12.4999 20.833ZM12.4999 22.9163C18.2529 22.9163 22.9166 18.2526 22.9166 12.4997C22.9166 6.74671 18.2529 2.08301 12.4999 2.08301C6.74695 2.08301 2.08325 6.74671 2.08325 12.4997C2.08325 18.2526 6.74695 22.9163 12.4999 22.9163Z",
    fill: "#CACCD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4999 7.29199C11.9246 7.29199 11.4583 7.75836 11.4583 8.33366C11.4583 8.90896 11.9246 9.37533 12.4999 9.37533C13.0752 9.37533 13.5416 8.90896 13.5416 8.33366C13.5416 7.75836 13.0752 7.29199 12.4999 7.29199ZM12.4999 11.4587C11.9246 11.4587 11.4583 11.925 11.4583 12.5003V16.667C11.4583 17.2423 11.9246 17.7087 12.4999 17.7087C13.0752 17.7087 13.5416 17.2423 13.5416 16.667V12.5003C13.5416 11.925 13.0752 11.4587 12.4999 11.4587Z",
    fill: "#CACCD1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleIcon);
export default __webpack_public_path__ + "static/media/InfoCircleIcon.9d12d873.svg";
export { ForwardRef as ReactComponent };